export default __webpack_public_path__ + "static/media/keto_fats@3x.d1160eb0.jpg";